module.exports = __webpack_public_path__ + "fonts/Poppins-Bold.c23534ac.ttf";